

import { Dropdown as DropdownPrimeReact } from 'primereact/dropdown';
import { useImperativeHandle, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useClickOutsides } from "shared/hooks";
import { FlexAlignCenter, Label } from "shared/ui-basics";
import styled from "styled-components";
import { StatusCode } from 'utils/optionsSets/OptionSets';



const TemplateSelection = ({ innerRef, className = 'w-100', personaRef, setHideSwimlaneSelection, ...props }) => {

    const { t } = useTranslation()
    const dropdownRef = useRef(null);
    const authorizedClickOuteClasses = ["p-dropdown-item", "ellipsis ms-2", "PersonaBubble__PersonaImage-sc-bui15p-1 jaEAuo", "ui-basics__FlexAlignCenter-sc-zh9sy2-3 dWpHJU"];
    const template = useSelector((state) => state.maps.all_maps).filter((map) => map.isTemplate === true && map.statusCode === StatusCode.Active && map.templateStatus === 100000001);
    const templateCemantica = [
        { value: "100000001", name: t("ASPX_117") },
        { value: "100000003", name: t("ASPX_256") },
        { value: "100000000", name: t("ASPX_116") },
    ];

    const [selected, setSelected] = useState(null);
    const ref = useClickOutsides(() => {
        if (dropdownRef.current) {
            dropdownRef.current?.hide();
        }
    }, authorizedClickOuteClasses); // due to primereact menu outisde the root element

    const organizationsTemplates = template.length > 0 ? [{
        label: t('YOUR_ORGANIZATION'), items: template.map((persona) => ({
            name: persona.name,
            value: persona.cjmId
        }))
    }] : [];

    const options = [{ label: t('CEMANTICA'), items: templateCemantica }, ...organizationsTemplates];

    const onChange = (e) => {
        setHideSwimlaneSelection(true)

        setSelected(e.value);
        if (e.value?.length > 10) {
            setHideSwimlaneSelection(true)
            const templatePersonas = template.find((temp) => temp.cjmId === e.value)?.linkedPersonas;
            const personaIds = templatePersonas?.map((persona) => persona.personaId);
            personaRef.current.setOptions(personaIds);
            personaRef.current.setSelectedPersona(personaIds[0]);
            return;
        }
        if (e.value === undefined) {
            personaRef.current.cleanOptions();
            setHideSwimlaneSelection(false)

        }
    }


    // to retrieve from parent component
    useImperativeHandle(innerRef, () => ({
        getSelectedTemplate: () => selected
    }))

    // template component for the dropdown
    const Templatelabel = (option, props) => {
        if (option?.items) {
            return <Label size={12} className='px-2'  style={{ pointerEvents: 'none' }}>{option?.label}</Label>
        }
        if (option) {
            return (
                <FlexAlignCenter >
                    <div className='ellipsis ms-2 w-100'>{option?.name}</div>
                </FlexAlignCenter>
            );
        }

        return props && <span>{props.placeholder}</span>;
    };
    return (
        <div ref={ref}>
            <Dropdown
                value={selected}
                onChange={onChange}
                options={options}
                optionLabel="name"
                 optionGroupLabel="label"
                optionGroupChildren="items"
                placeholder={t("SELECT_TEMPLATE")}
                filter={props.search ? true : false}
                valueTemplate={Templatelabel}
                itemTemplate={Templatelabel}
                className={className}
                ref={dropdownRef}
                showClear

            />
        </div>


    )
}

const Dropdown = styled(DropdownPrimeReact)`
.p-inputtext {
    padding: 0.4rem 0.75rem;
}


`


export default TemplateSelection;